import httpRequest from "../../../infrastructure/httphelper";
import sharedGlobals from "../../../sharedglobals";

class WorkFlowService {
    constructor() {}



    getNotifications() {
        let url =
          sharedGlobals.appUrls.workflowUrl + "api/Workflow/GetApprovalLogsForUser";
        return httpRequest({
          url: url,
          method: "POST",
        });
      }

      getApprovalDetails(processSessionId){
        let param = {
            processSessionId: processSessionId,
          };
          let url =
            sharedGlobals.appUrls.workflowUrl +
            "api/Workflow/GetApprovalDetails";
          return httpRequest({
            url: url,
            method: "POST",
            params: param,
          });
      }
      executeProcessAction(input){
        let url =
        sharedGlobals.appUrls.workflowUrl + "api/Workflow/ExecuteProcessAction";
        return httpRequest({
          url: url,
          method: "POST",
          data: input
        });
      }
      initiateProcess(input){
        let url =
        sharedGlobals.appUrls.workflowUrl + "api/Workflow/InitiateProcess";
        return httpRequest({
          url: url,
          method: "POST",
          data: input
        });
      }
}

let instance = new WorkFlowService();
export default instance;